import React from 'react';
import {formatDate} from 'utils/datetime';

import './styles.css';

const AllocationHeader = ({header, room}) => (
  <div className="allocationHeader">
    <div className="header">{header}</div>
    <div className="room"> {room}</div>
  </div>
);

const Period = ({header, start, end}: any) => (
  <div className="Period">
    {header && <div className="header">{header}</div>}
    <div className="date">
      {formatDate(start)} - {formatDate(end)}
    </div>
  </div>
);

const AllocationToDelete = ({allocation, header}) => (
  <div className="AllocationToDelete">
    <AllocationHeader header={header} room={allocation.room} />
    <div className="PeriodSection">
      <Period start={allocation.startDate} end={allocation.endDate} />
    </div>
  </div>
);

export default AllocationToDelete;
